<div class="container-fluid">
  <div class="row ml-lg-1  movie-height-scroll">
    <div class="col-3 col-xl-2 mt-4 d-none d-lg-block" style="background: rgba(0,0,0,0.4);">
      <div class="row mt-2 p-2">
        <div class="col-4 mb-0 ml-2 p-0 mt-1 pr-1 d-flex mr-3">
          <h4 class="categories-res">{{'NAV.NAV7' | translate}}</h4>
        </div>
        <div class="col-3 mb-2 ml-auto mt-0 pr-1 d-flex mr-1">

          <!-- <div class="sort-back border-dark text-white fs-22 px-2" (click)="sort('category_name')">
            <i class="fas fa-sort-alt"></i></div> -->
          <button type="button" triggers="click" outsideClick="true" popover-trigger=" 'outsideClick' " [popover]="popTemplateCat" class="sort-back border-dark text-white fs-22 px-2 "
            placement="right">
            <i class="fas fa-sort-alt"></i>
          </button>
          <ng-template #popTemplateCat>
            <div *ngFor="let item of sortButton; let i = index" class="mt-2">
              <button triggers="click" outsideClick="true" [ngClass]="{'btn-purple': item.selected}" (click)="sort('category_name',item.val)" type="button"
                class="btn sort-btn btn-dark">
                {{translateFilter(i) | translate}} </button>
            </div>
          </ng-template>
        </div>
        <!-- <div class="col-12" style="padding-left: 8px;padding-right: 8px;">
          <div class="w-100">
              <span class="icon"><i class="fa fa-search"></i></span>
              <input type="text" class="chh-input" [(ngModel)]="filterTerm" id="search" (keyup)="searchTextsChannel($event)" placeholder="{{ 'COMMON.SEARCH_HERE' | translate }}" maxlength="255" />
          <span class="search-x cursor-pointer text-dark" matTooltip="Clear search" *ngIf="filterTerm" (click)="clearSearchChannel()"><i class="fa fa-times"></i></span>
        </div>
      </div> -->
               <div class="col-12" style="padding-left: 8px;padding-right: 8px;">

                      <div class="w-100">
                          <span class="icon"><i class="fa fa-search"></i></span>
                          <input type="text" class="chh-input" [(ngModel)]="searchTextChannel" id="search" (keyup)="searchTextsChannel($event)" placeholder="{{ 'COMMON.SEARCH_HERE' | translate }}" maxlength="255" />
                          <span class="search-x cursor-pointer text-dark" matTooltip="Clear search" *ngIf="searchTextChannel" (click)="clearSearchChannel()"><i class="fa fa-times"></i></span>
                        </div>
                    </div>
        <div class="col-12 justify-content-between p-2 mt-0 cat-list-res">
          <div *ngIf="searchedCategory && searchedCategory.length > 0 " class="d-flex  flex-column  mb-2 bd-highlight category-box " [ngClass]="{'bd-highlight-selected': id === true}">
            <a class=" bd-highlight over p-2 pt-3 pb-3" (click)="updateSelectedId('all')" style="cursor: pointer;text-decoration: none;">All</a>
          </div>
          <div class="d-flex flex-column category-box bd-highlight  mb-2" *ngIf="laodCategories">
            <div class="d-flex justify-content-center align-item-center cursor-pointer" (click)="loadSeriesCategories()">
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
              </svg>
              <div *ngIf="isLoading" class="spinner-border spinner-border-lg fs-34" style="vertical-align:middle;" role="status"></div>
            </div>
          </div>
          <div class="d-flex  mt-2 mb-2 cursor-pointer justify-content-between align-items-center bd-highlight category-box" (click)="updateSelectedId(category.category_id)" *ngFor="let category of searchedCategory; index as i" [ngClass]="{'bd-highlight-selected': category.select}" >
            <div class="cat-texts">
            <a class="mt-2 ml-2 bd-highlight over" 
            style="cursor: pointer;text-decoration: none;">{{category.category_name}}</a>
            </div>
            <div class="cat-id d-flex align-items-center">
              <!-- <p class="pr-2">{{category.category_id}}</p> -->
              <p class="pr-2"></p>
            </div>
          </div>
          <div class="no-data-found" *ngIf="searchedCategory.length<=0">
            <p class="d-flex align-item-center justify-content-center">
              No Data found
            </p>
          </div>
          <!-- [ngClass]="{'btn-selected': category.select}"  -->
        </div>
      </div>
    </div>
    <div class="col-9 col-xl-10 mb-0 pb-0 d-none d-lg-block">
      <app-series-grid [selectedcategory]="selectedcategory" [isLoading]="isLoading"></app-series-grid>
    </div>
    <div class="col-12 mt-4 d-lg-none d-block p-res">
      <div class="row">
        <div class="col-12 text-center category-border" (click)="isCategory=!isCategory">
          <p class="sub-text border p-2">{{ 'COMMON.CATEGORIES' | translate }}
            <i class="fa fa-chevron-down ml-2"></i></p>
        </div>
        <div class="col-12 px-2" *ngIf="isCategory === true">

          <!-- <div class="sort-back border-dark text-white fs-22 ml-auto mr-2" (click)="sort('category_name')">
              <i class="fas fa-sort-alt"></i></div> -->
        <div class="d-flex  ml-auto mt-1 mr-3 px-3 mr-3" style="padding-left: 0.5rem !important;padding-right: 0rem !important;margin-right: 0rem !important;">
          <div class="w-100">
                      <div class="w-100 w-99">
                          <span class="icon"><i class="fa fa-search"></i></span>
                          <input type="text" class="chh-input" [(ngModel)]="searchTextChannel" id="search" (keyup)="searchTextsChannel($event)" placeholder="{{ 'COMMON.SEARCH_HERE' | translate }}" maxlength="255" />
                          <span class="search-x cursor-pointer text-dark" matTooltip="Clear search" *ngIf="searchTextChannel" (click)="clearSearchChannel()"><i class="fa fa-times"></i></span>
                        </div>
                    </div>
            <button type="button" [popover]="popTemplateCat" triggers="click" outsideClick="true" popover-trigger=" 'outsideClick' " class="sort-back border-dark text-white fs-22 ml-auto ">
              <i class="fas fa-sort-alt"></i></button>
          </div>

          <ng-template #popTemplateCat >
            <div *ngFor="let item of sortButton" class="mt-2">
              <button [ngClass]="{'btn-purple': item.selected}" (click)="sort('category_name',item.val)" type="button"
                class="btn sort-btn btn-dark">
                {{ item.label }}
              </button>
            </div>
          </ng-template>
         
          <div class="col-12 color-scroll" style="height: 50vh;overflow-y: scroll;">
            <div class="d-flex  mt-2 mb-2 cursor-pointer justify-content-between align-items-center bd-highlight category-box" (click)="updateSelectedId(category.category_id)" *ngFor="let category of searchedCategory; index as i" [ngClass]="{'bd-highlight-selected': category.select}" >
              <div class="cat-texts">
                <a class="mt-2 ml-2 bd-highlight over" 
                style="cursor: pointer;text-decoration: none;">{{category.category_name}}</a>
              </div>
            </div>
            <div class="no-data-founds" *ngIf="searchedCategory.length<=0">
            <p class="d-flex align-item-center justify-content-center">
              No Data found
            </p>
          </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-12 m-0 p-0 d-lg-none d-block">
      <app-series-grid [selectedcategory]="selectedcategory"></app-series-grid>
    </div>
  </div>
</div>
